
export const initialValues = {
  listShortName: "",
  dropdownListName: "",
  dropdownId: "",
  activeStatus: 1,

}